'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveData = require('./reactiveData.js');

var _reactiveData2 = _interopRequireDefault(_reactiveData);

var _reactiveProp = require('./reactiveProp.js');

var _reactiveProp2 = _interopRequireDefault(_reactiveProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  reactiveData: _reactiveData2.default,
  reactiveProp: _reactiveProp2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-chartjs/es/mixins/index.js
// module id = 1805
// module chunks = 1